import React, { ReactNode } from 'react';
import * as serviceWorker from './serviceWorker';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { Error500 } from './theme/components/ErrorPage';
import { webConfig } from './webConfig';
import { ThemeApp, RouterApp } from './App';
import mixpanel from 'mixpanel-browser';

mixpanel.init(webConfig.mixpanelToken, {
    debug: false,
    track_pageview: false,
    persistence: 'localStorage',
    loaded: () => {
        window.mixpanel = {
            initialized: true,
        };
    },
});

// Sentry.init({ // TODO: -- revert
//     environment: webConfig.environment,
//     dsn: webConfig.sentryUrl,
// });

const SentryErrorBoundary = Sentry.ErrorBoundary as React.ComponentType<
    React.PropsWithChildren<{ fallback?: React.ReactNode }>
>;

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);
root.render(
    <React.StrictMode>
        <SentryErrorBoundary fallback={<Error500 />}>
            <ThemeApp>
                <RouterApp />
            </ThemeApp>
        </SentryErrorBoundary>
    </React.StrictMode>,
);

// ReactDOM.render(
//     <React.StrictMode>
//         <Sentry.ErrorBoundary fallback={Error500}>
//             <ThemeApp>
//                 <RouterApp />
//             </ThemeApp>
//         </Sentry.ErrorBoundary>
//     </React.StrictMode>,
//     document.getElementById('root'),
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
